export const makeType = mode => type=> `${mode}${type}` ;


export const actionCreator = (type,...argsNames)=>(...args)=>{
    const action = {type}
    argsNames.forEach((arg,index)=>{
        action[argsNames[index]] = args[index]
    })
    return action
}
